import set from 'lodash/set'
import isEmpty from 'lodash/isEmpty'
import type { TreeMapOptions, TreeMapPredicate } from './types'
import cloneDeep from 'lodash/cloneDeep'
import get from 'lodash/get'

/**
 * This function works like the Array.map but traverse the tree structure and return a new tree structure
 * @param root
 * @param predicate
 * @param options
 */

export function mapTree<T>(root: T, predicate: TreeMapPredicate<T>, options?: TreeMapOptions): T {
  //we need a new copy here to avoid mutation of the root
  const clonedRoot = cloneDeep(root)

  const childrenName = options?.childrenName ?? 'items'

  const traverse = (traverseRoot: T, level: number) => {
    const children = get(traverseRoot, childrenName, []) as T[]

    const mappedChildren = children.map<T>((node, index): T => {
      const mappedNode = predicate(node, level + 1, index, traverseRoot)

      const nodeChildren = get(node, childrenName, []) as T[] //(node?.[childrenName] ?? []) as T[]

      if (Array.isArray(nodeChildren) && !isEmpty(nodeChildren)) {
        //we need a set here to we can still work with dotNotation for childrenName
        // Recursively map children
        return set<T>(
          {
            ...mappedNode,
          } as object,
          childrenName,
          traverse(mappedNode, level + 1)
        )
      }

      // If there are no children, return the mapped node
      return { ...mappedNode } as T
    })

    return mappedChildren
  }

  const mappedRoot = predicate(clonedRoot, 0, 0, null)
  //we need a set here to we can still work with dotNotation for childrenName
  const result = set<T>(
    {
      ...mappedRoot,
    } as object,
    childrenName,
    traverse(clonedRoot, 0)
  )

  return result
}
